import { type ReactNode, Suspense, useState } from 'react';

import { Icon } from '@eduzz/ui-antd-theme';

import { fieldsFromSaved } from '@/lib/fieldsFromSaved';
import { seedCompletedSteps } from '@/lib/gtm';
import { trpc } from '@/lib/trpc';
import { registryStore } from '@/stores/registry';

import Header from './Header';

const HydrateGate = ({ children }: { children: ReactNode }) => {
  const [{ saved }] = trpc.registry.getStatus.useSuspenseQuery();

  useState(() => {
    if (saved) {
      registryStore.getState().setFields(fieldsFromSaved(saved as Record<string, unknown>));
    }

    seedCompletedSteps(registryStore.getState().registry as unknown as Record<string, unknown>);
    return true;
  });

  return <>{children}</>;
};

const LoadingScreen = () => (
  <>
    <Header />
    <section className='flex flex-1 items-center justify-center'>
      <Icon.LoaderCircle className='mb-8 animate-spin text-5xl text-(--uizz-antd-color-primary)' />
    </section>
  </>
);

export const RegistryBootstrap = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<LoadingScreen />}>
    <HydrateGate>{children}</HydrateGate>
  </Suspense>
);
